import { ICompanyV1 } from '../tools/api.service';
import { Injectable } from "@angular/core";

@Injectable()
export class Company {
  unisiteCode: string;
  socialReason: string;
  address: string;
  postalCode: string;
  city: string;
  country: string;
  siret: string;
  tva: string;

  public static parseToCompany(item: Company): ICompanyV1 {
    let result = new ICompanyV1();
    result.unisiteCode = item.unisiteCode;
    result.socialReason = item.socialReason;
    result.address = item.address;
    result.postalCode = item.postalCode;
    result.city = item.city;
    result.country = item.country;
    result.siret = item.siret;
    result.tva = item.tva;

    return result;
  }
}
